import React, { useState, useRef } from "react";
import { Icon, Dropdown } from "semantic-ui-react";
import html2canvas from "html2canvas";
import moment from "moment";
import { kFormatter } from "../../../../../Dashboard/Charts/utils";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import DimmerComponent from "../../../../../Dashboard/DimmerComponent";
import { downloadCSVData, downloadCanvasWithTitle } from "../../../../../Dashboard/Charts/utils";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import FBPageSelector from "../../../../../FbInsights/FBPageSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../../../../assets/svg/downloads.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import TwitterPageSelector from "../TwitterPageSelector";
import "./TotalValueCharts.scss";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";

function TotalFollowings(props) {
    const chart = useRef(null);
    const [downloading, setDownloading] = useState(false);
    const chartEl = useRef();
    let nodata = props.pageStatus || !props.data;

    // let current = 1000;
    // let previous = 580;
    let current = props.data?.current?.following_count;
    let previous = props.data?.previous?.following_count;

    // const renderDownloadButton = (nodata) => {
    //     return (
    //         <Dropdown
    //             disabled={nodata}
    //             trigger={
    //                 <div className="chart-header-icon">
    //                     <DownloadIcon data-html2canvas-ignore="true" className="chart-download-icon" />
    //                 </div>
    //             }
    //             icon={null}
    //             className="chart-download-dropdown hideable"
    //             direction="left">
    //             <Dropdown.Menu>
    //                 <Dropdown.Item onClick={downloadCSV}>CSV</Dropdown.Item>
    //                 <Dropdown.Item onClick={downloadPNG}>PNG</Dropdown.Item>
    //             </Dropdown.Menu>
    //         </Dropdown>
    //     );
    // };

    // const downloadPNG = () => {
    //     if (props.isFreeTierPackage) {
    //         props.packageUpgradePopup();
    //         return;
    //     }
    //     setDownloading(true);

    //     return html2canvas(chartEl.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
    //         (canvas) => {
    //             setDownloading(false);
    //             downloadCanvasWithTitle(canvas, props.widget?.name || "Total following");
    //         },
    //     );
    // };

    // const downloadCSV = () => {
    //     if (props.isFreeTierPackage) {
    //         props.packageUpgradePopup();
    //         return;
    //     }
    //     setDownloading(true);
    //     const columns = [["Duration"], ["Current"], ["Previous"], ["Percentage Change"]];

    //     if (props.appliedFilter.duration !== "custom") columns[0].push(props.appliedFilter.duration + " days");
    //     else {
    //         const startDate = moment(new Date(props.appliedFilter.start_date).toLocaleDateString());
    //         const endDate = moment(new Date(props.appliedFilter.end_date).toLocaleDateString());
    //         const duration = endDate.diff(startDate, "days") + 1;

    //         columns[0].push(duration + " days");
    //     }
    //     columns[1].push(kFormatter(current));
    //     columns[2].push(kFormatter(previous));

    //     let percentageChange =
    //         current > previous
    //             ? `+ve ${(((current - previous) / previous) * 100).toFixed(2)}%`
    //             : current < previous
    //             ? `-ve ${(((previous - current) / previous) * 100).toFixed(2)}%`
    //             : "0%";

    //     columns[3].push(percentageChange);

    //     let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

    //     setDownloading(false);
    //     downloadCSVData(csvFmt, props.widget?.name || "Total following");
    // };

    const increment = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === props.twitterPageList.length - 1) props.setSelectedTwitterPage(props.twitterPageList[0]);
        else props.setSelectedTwitterPage(props.twitterPageList[index + 1]);
    };

    const decrement = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === 0) props.setSelectedTwitterPage(props.twitterPageList[props.twitterPageList.length - 1]);
        else props.setSelectedTwitterPage(props.twitterPageList[index - 1]);
    };
    const renderDownloadButton = () => {
        return (
            <DownloadChart
                nodata={false}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };
    const downLoadCSV = () => {
        let chartName = props.widget?.name || "Total Following";

        let downLoadingData = [];
        // let durationGap = chartData?.durationGap + 1;

        // downLoadingData.push(["Duration", "Current", "Average", "Previous", "Percentage change"]);
        downLoadingData.push([chartName]);
        // let percentage = chartData?.percentage_change;
        // if (preCount) downLoadingData.push([duration + " days", postCount, preCount, percentage + "%"]);
        // else
        // downLoadingData.push([duration + " days", postCount, "NA", "NA"]);
        downLoadingData.push([current + " Following"]);

        downloadCSVData(downLoadingData, chartName);
    };

    const downLoadPNG = (cb) => {
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, props.widget?.name || "Total Following");
                },
            );
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName isTwitter isTWPage={props.isTWPage} name={props.widget?.name || "Total Following"} info="Total number of users you are following " />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isPublic && !props.isResearchDashboard && renderDownloadButton()}
                </div>
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isTWPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {/* {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>} */}

                    {
                        <>
                            {(props.isPublic && nodata) || props.isTWPage ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }

                    {!props.isPublic && !props.isTWPage && (
                        <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />
                    )}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}
            {!nodata ? (
                // <div className="dashboard-chart  dashboard-chart-slider skiptranslate" ref={chartEl}>
                // {!props.isTWPage && (
                //     <div
                //         data-html2canvas-ignore="true"
                //         className={`chart-slider chart-slider-left ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                //         onClick={decrement}>
                //         <ArrowIcon />
                //     </div>
                // )}
                <div style={{ height: "100%" }} className="chart-area" ref={chart}>
                    {!props.isTWPage && props.selectedTwitterPage && (
                        <TwitterPageSelector
                            selectedTwitterPage={props.selectedTwitterPage}
                            setSelectedTwitterPage={props.setSelectedTwitterPage}
                            twitterPageList={props.twitterPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    <div className="totalValueCharts">
                        <div className="currentPeriod">
                            <p className="row-1">{kFormatter(current)}</p>
                            <p className="row-2">Total Followings</p>
                        </div>
                        <div className="previousPeriod">
                            {current > previous ? (
                                <p className="positivePercentageChange">+{(((current - previous) / previous) * 100).toFixed(2)}%</p>
                            ) : current === previous ? null : (
                                <p className="negativePercentageChange">-{(((previous - current) / previous) * 100).toFixed(2)}%</p>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                // {!props.isTWPage && (
                //     <div
                //         data-html2canvas-ignore="true"
                //         className={`chart-slider chart-slider-right ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                //         onClick={increment}>
                //         <ArrowIcon />
                //     </div>
                // )}
                // </div>
                <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
            )}
            {(!props.selectedTwitterPage || props.loading) && <DimmerComponent />}
        </>
    );

    return props.isTWPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default TotalFollowings;
